import { render, staticRenderFns } from "./PlanetDataDestination.vue?vue&type=template&id=499a36ea&scoped=true&"
import script from "./PlanetDataDestination.vue?vue&type=script&lang=js&"
export * from "./PlanetDataDestination.vue?vue&type=script&lang=js&"
import style0 from "./PlanetDataDestination.vue?vue&type=style&index=0&id=499a36ea&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "499a36ea",
  null
  
)

export default component.exports